import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoRespaldo } from '../_models/requisito-respaldo';
import {RequisitoRespaldoTipoVinculacion} from '../_models/requisito-respaldo-tipo-vinculacion';
import {RequisitoRespaldoProducto} from '../_models/requisito-respaldo-producto';

@Injectable({
  providedIn: 'root'
})
export class RequisitosRespaldosProductosService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasRespaldosProductos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoRespaldoProducto[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as RequisitoRespaldoProducto[] ) );
  }

  listadoHabilitadosPorUnidadCredito( idSolUc: string ) {
    return this.httClient.get( this.rutServicio + '/solicitudUnidadCredito/' + idSolUc ).pipe( map( res => res as RequisitoRespaldoProducto[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoRespaldoProducto ) );
  }

  obtenerPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantiaRespaldo/' + id ).pipe( map( res => res as RequisitoRespaldoProducto[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantiaRespaldo/' + id + '/enabled' ).pipe( map( res => res as RequisitoRespaldoProducto[] ) );
  }

  crear( regCrear: RequisitoRespaldoProducto ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoRespaldoProducto ) );
  }

  bulk( regCrear: RequisitoRespaldoProducto[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as
      RequisitoRespaldoProducto ) );
  }

  actualizar( regActualizar: RequisitoRespaldoProducto ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
